
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import { usercheckedinhotel,usercheckedinhotel_deleterecord } from "../dbconnector/connector";
import { useState } from 'react';
import hotelcss from './css/hotelhotellist.module.css';
import './css/tabs.css'
import { MdDelete } from "react-icons/md";
import { confirmAlert } from 'react-confirm-alert';



const Loginlist = (props) => {
    const t = props.translation
    const [checkedinusers, setCheckedinusers] = useState({});
     const [listarray, setListArray] = useState([]);
         const [iconDisabled, setIconDisabled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

        try {
            const Usercheckedinhotel = usercheckedinhotel();
            Usercheckedinhotel.then((result) => {
                if (result.status === 200) {
                    setCheckedinusers({})
                    result.json().then(res => {
                        // console.log("test" , res)
                        setCheckedinusers(res)


                    })
                    //setEmployeelist(result)
                    // createlist(props.translation, result.items, navigate)
                } else {
                    setErrorMessage(result.status + ": " + result.message)
                }

            })
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }

    }, []);

    useEffect(() => {
        try {
           
            if (checkedinusers !== null && checkedinusers !== undefined && checkedinusers.length > 0) {
                 console.log("loaded from DB", checkedinusers)
                //console.log("loaded from DB", checkedinusers)
                 setListArray([])
                checkedinusers.forEach( (element ,index) => {
                    console.log("element", element)
                      setListArray(pre => [...pre,
                      <div id={element.id} className={index % 2 === 0 ? hotelcss.loginlist_Varient1 : hotelcss.loginlist_Varient2} >
                            {/* <p>{item.nr_afd}</p> */}
                            <div>{element.id}</div>
                            <div>{element.hotel_Id}</div>
                            <div>{element.werknemers_Id}</div>
                            <div>{element.nightshift}</div>
                             <MdDelete onClick={iconDisabled ? null : () => handlecleaningTypeDeleteClick(element)} ></MdDelete>
                            {/* <input id={item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_Id} checked={true} disabled={true} ></input> */}
                            <p></p>
                        </div>
                      ])
                });
                // checkedinusers[0].forEach((item, index) => {
                // console.log("test" , item)
                // setHotelArray(pre => [...pre,
                // <div id={item.Hotel_Id} className={index % 2 === 0 ? hotelcss.hotellinkVarient1_view : hotelcss.hotellinkVarient2_view} >
                //     {/* <p>{item.nr_afd}</p> */}
                //     <p>{item.Name}</p>
                //     <p></p>
                //     {/* <input id={item.Hotel_ID} type='CheckBox' className="checkbox" name={item.Hotel_Id} checked={true} disabled={true} ></input> */}
                //     <p></p>
                // </div>
                // ])
                // });
            }
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }

    }, [checkedinusers]);
 const handlecleaningTypeDeleteClick = (item) => {
        //////console.log(item)
        const options = {
            title: t("Delete?"),
            message: "Bent u zeker dat u deze record uit de database wenst te verwijderen? Deze actie is onomkeerbaar.",
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = usercheckedinhotel_deleterecord(item.id)
                        response.then(res => {
                             setCheckedinusers({})
                            res.json().then(res => {
                                console.log(res)
                               setCheckedinusers(res)
                            }
                            )

                        })

                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="content">
                     <div id="headertable" className={hotelcss.tableheader_loginlist}><p id="ID">record id</p><p id="hotel_id">hotel_id</p><p id="werknemers_id">werknemers_id</p><p id="nightshift">nightshift</p><p></p></div>
                     <div id="resultlist" className='loginlist'>
                         {listarray}
                    </div>
                </div>
            </div>
        </>
    )

}

export default Loginlist